import {gql, useMutation} from '@apollo/client';

const markActionPlanOnboardingCompleteMutation = gql`
  mutation markActionPlanOnboardingComplete {
    markActionPlanOnboardingComplete {
      id
      completedActionPlanOnboarding
    }
  }
`;

export const useMarkActionPlanOnboardingComplete = () => {
  const [markActionPlanOnboardingComplete, {loading: updatingActionPlanOnboardingComplete}] =
    useMutation(markActionPlanOnboardingCompleteMutation);

  return {markActionPlanOnboardingComplete, updatingActionPlanOnboardingComplete};
};
